import { PlusOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import { Space, Table, Popconfirm, Popover, Button, notification } from 'antd'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { CTAButton } from '../../components'
import NewIrrelevantTitle from './new'
import UpdateIrrelevantTitle from './edit'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    topButton: {
        width: '80%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    content: {
        padding: theme.spacing(3, 0)
    },
    table: {
        maxWidth: '100%',
        width: '100%'
    }
}))


/**
 * page to add irrelevant titles
 */
const IrrelevantTitles = (props) => {
    const [irrelevantTitles, setIrrelevantTitles] = useState([])
    const [show, setShow] = useState(false)
    const [editShow, setEditShow] = useState(false)
    const [title, setTitle] = useState({})
    const [error, setError] = useState(null)
    const classes = useStyles()
    const data = useData()
    const titles = data.titles()

    const newTitle = () => setShow(true)
    const updateTitle = (record) => {
            setEditShow(true);
            setTitle(record);
        }

    const irrelevantTitleSchema = [
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id'
        },
        {
            title: 'Title',
            key: 'title',
            dataIndex: 'title',
            sorter: (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
        },
        {
            title: 'Date Created',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (date) => moment(date).format("YYYY-MM-DD HH:mm")
        },
        {
            title: 'Date Updated',
            key: 'updated_at',
            dataIndex: 'updated_at',
            render: (updated_at) => moment(updated_at).format("YYYY-MM-DD HH:mm")
        },
        {
            key: 'Actions',
            title: 'Actions',
            render: (_, record) => {
                return (
                <Space>
                    <Button type='primary' size='small' onClick={() => updateTitle(record)}  icon={<FormOutlined />} />
                    <Popconfirm
                        title="Are you sure to delete this irrelevant title?"
                        onConfirm={ () => deleteIrrelevantTitles(record.id) }
                        okText="Yes"
                        cancelText="No"
                    >
                    <Button danger size='small'  icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
                )
            }
        },
    ]

    const deleteIrrelevantTitles = ( id ) => {
        titles.deleteUnclearIrrelevantTitle(id)
            .then((data) => {
                notification.success({
                    message: "Irrelevant titles deleted successfully."
                })
                loadIrrelevantTitles()
            })
    }

    const loadIrrelevantTitles = () => {
        trackPromise(
            titles.getUnclearIrrelevantTitles("not relevant")
                .then(a => {
                    console.log(a)
                    setIrrelevantTitles(a)
                })
                .catch(console.log)
        )
    }

    const publishIrrelevantTitles = () => {
        setError(null)
        trackPromise(
            titles.publishTitles("not relevant")
                .then(a => {
                    console.log(a)
                    notification.success({
                        message: "Irrelevant titles published successfully."
                    })
                })
                .catch(err => {
                    console.log(err.message)
                    setError("An error occured")
                })
        )
    }

    // load the irrelevant titles
    useEffect(() => {
        loadIrrelevantTitles()
    }, [])

    const {promiseInProgress} = usePromiseTracker()

    const closeDrawer = () => {
        setShow(false)
        setEditShow(false)
        loadIrrelevantTitles()
    }

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <h1>Irrelevant Titles</h1>
                <div className={classes.topButton}>
                    <div style={{marginRight: 10}}>
                        <Popconfirm
                            title="Are you sure to publish all irrelevant titles?"
                            onConfirm={ () => publishIrrelevantTitles() }
                            okText="Yes"
                            cancelText="No"
                        >
                            <CTAButton onClick={null} type={"submit"} >
                            Publish Irrelevant Title
                            </CTAButton>
                        </Popconfirm>
                    </div>
                    <CTAButton onClick={newTitle}>
                        <PlusOutlined />
                        Add Irrelevant Title
                    </CTAButton>
                </div>
            </div>

            <div className={classes.content}>
                <Table
                    columns={irrelevantTitleSchema}
                    className={classes.table}
                    loading={promiseInProgress}
                    dataSource={irrelevantTitles}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        total: irrelevantTitles.length,
                        pageSizeOptions: ['10', '20', '50', '100', '200', '500'],
                        showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} titles`,
                    }}
                />
            </div>

            <NewIrrelevantTitle visible={show} close={closeDrawer} />
            <UpdateIrrelevantTitle title={title} visible={editShow} close={closeDrawer} />
        </div>
    )
}

export default IrrelevantTitles